import { ReactComponent as CloseIcon } from '@svgs/close.svg'
import styles from './styles.module.scss'

type FiltersHeaderProps = {
  onClose: () => void
}

export default function FiltersHeader({ onClose }: FiltersHeaderProps) {
  return (
    <div className={styles.header}>
      <h3>Filter</h3>
      <button className={styles.closeButton} onClick={onClose}>
        <CloseIcon width="16" height="16" />
      </button>
    </div>
  )
}
